/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategoryemail2Inputs */

const en_filecategoryemail2 = /** @type {(inputs: Filecategoryemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const pt_filecategoryemail2 = /** @type {(inputs: Filecategoryemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Filecategoryemail2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategoryemail2 = /** @type {((inputs?: Filecategoryemail2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategoryemail2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategoryemail2(inputs)
	return pt_filecategoryemail2(inputs)
});
export { filecategoryemail2 as "fileCategoryEmail" }